import React from 'react';

const AdminZone = ({ onNavigate }) => {
  return (
    <div>
      <h2 style={{ fontSize: '18px', color: 'var(--color-text)', marginBottom: '15px', borderBottom: '2px solid var(--color-border)', paddingBottom: '10px' }}>Admin Zone</h2>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '20px', marginBottom: '40px' }}>
        <div onClick={() => onNavigate('bot-manager')} style={cardStyle}>
          <h3 style={{ margin: '0 0 10px 0', color: 'var(--color-primary)' }}>🤖 Bot Message Manager</h3>
          <p style={{ color: 'var(--color-text-muted)' }}>Manage chat bot messages and replies</p>
        </div>

        <div onClick={() => onNavigate('message-log')} style={cardStyle}>
          <h3 style={{ margin: '0 0 10px 0', color: 'var(--color-primary)' }}>📊 Message Analytics</h3>
          <p style={{ color: 'var(--color-text-muted)' }}>Analyze user messages and insights</p>
        </div>

        <div onClick={() => onNavigate('feature-manager')} style={cardStyle}>
          <h3 style={{ margin: '0 0 10px 0', color: 'var(--color-primary)' }}>🛠 Feature Manager</h3>
          <p style={{ color: 'var(--color-text-muted)' }}>Toggle services on/off</p>
        </div>

        <div onClick={() => onNavigate('user-manager')} style={cardStyle}>
          <h3 style={{ margin: '0 0 10px 0', color: 'var(--color-primary)' }}>👥 User Manager</h3>
          <p style={{ color: 'var(--color-text-muted)' }}>View and manage all system users</p>
        </div>

        <div onClick={() => onNavigate('lending-tracker')} style={cardStyle}>
          <h3 style={{ margin: '0 0 10px 0', color: 'var(--color-primary)' }}>🤝 Lending Tracker</h3>
          <p style={{ color: 'var(--color-text-muted)' }}>Track items you lent or borrowed</p>
        </div>
      </div>
    </div>
  );
};

const cardStyle = {
  border: '1px solid rgba(120, 180, 200, 0.35)',
  borderRadius: '18px',
  padding: '24px',
  cursor: 'pointer',
  background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.92) 0%, rgba(220, 244, 252, 0.8) 100%)',
  boxShadow: '0 12px 24px rgba(30, 70, 90, 0.12)',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
  transition: 'transform 0.2s ease, box-shadow 0.2s ease'
};

export default AdminZone;
